import React from 'react';
import { useEditorContext } from '../../Editor/Context';
import Reaction from '../buttons/Reaction';
import Deviation from '../buttons/Deviation';
import Gif from '../buttons/Gif';
import { useForceUpdate } from '../../../hooks/useForceUpdate';
import cn from 'classnames';
import Gallery from '../buttons/Gallery';
import Video from '../buttons/Video';
import s from './PluginInsertMenu.scss';
const PluginInsertMenu = ({ className })=>{
    const editor = useEditorContext();
    const forceUpdate = useForceUpdate();
    // Listen to editor as its not react so we need to react here
    editor === null || editor === void 0 ? void 0 : editor.on('transaction', ()=>{
        forceUpdate();
    });
    if (!editor) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, /*#__PURE__*/ React.createElement(Reaction, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Deviation, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Gallery, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Gif, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Video, {
        editor: editor
    }));
};
PluginInsertMenu.displayName = 'PluginInsertMenu';
export default PluginInsertMenu;

//# sourceMappingURL=PluginInsertMenu.js.map